// extracted by mini-css-extract-plugin
module.exports = {"creatorOwner":"Arts_creatorOwner__220sH"};